package org.vreo.devicehub.features.device.presentation.deviceList.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.stringResource

import devicehub.composeapp.generated.resources.Res
import devicehub.composeapp.generated.resources.device_menu_item_delete_label
import devicehub.composeapp.generated.resources.device_menu_item_open_label
import devicehub.composeapp.generated.resources.device_menu_item_unlink_label

/**
 * Device drop down menu
 *
 * @param openItemClick on open item click handler, if set to null item will be disabled
 * @param unlinkItemClick on unlink item click, if set to null item will be disabled
 * @param deleteItemClick on delete item click, if set to null item will be disabled
 */
@Composable
fun DeviceDropDownMenu(
    openItemClick: (() -> Unit)? = null,
    unlinkItemClick: (() -> Unit)? = null,
    deleteItemClick: (() -> Unit)? = null,
) {
    var expanded by remember { mutableStateOf(false) }

    Box(
        modifier = Modifier
            .padding(8.dp)
    ) {
        IconButton(
            onClick = {
                expanded = !expanded
            },
        ) {
            Icon(
                imageVector = Icons.Default.MoreVert,
                contentDescription = null
            )
        }

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = {
                expanded = false
            },
            modifier = Modifier.padding(8.dp)
        ) {
            DeviceDropDownItem(
                text = stringResource(Res.string.device_menu_item_open_label),
                onClick = {
                    expanded = false
                    openItemClick?.invoke()
                },
                enable = openItemClick != null
            )

            DeviceDropDownItem(
                text = stringResource(Res.string.device_menu_item_unlink_label),
                onClick = {
                    expanded = false
                    unlinkItemClick?.invoke()
                },
                enable = unlinkItemClick != null
            )

            DeviceDropDownItem(
                text = stringResource(Res.string.device_menu_item_delete_label),
                onClick = {
                    expanded = false
                    deleteItemClick?.invoke()
                },
                enable = deleteItemClick != null
            )
        }
    }
}

/**
 * Device drop down item
 *
 * @param text text of the menu item
 * @param onClick on item click handler
 * @param enable whether the item is enabled or not
 */
@Composable
private fun DeviceDropDownItem(
    text: String,
    onClick: () -> Unit,
    enable: Boolean = true
) {
    if (enable) {
        DropdownMenuItem(
            text = { Text(text) },
            onClick = onClick,
        )
    }
}